// React
import React from 'react';
// Design System (@lux)
import { Modal, ModalSize } from '@lux/modal';
import { TitlePreset } from '@lux/title';
import { CrossS } from '@lux/zds-icons';
import { Preset, Text } from '@lux/text';
// Pegasus
import { Translate, TranslateScope, useTranslate } from '@pegasus/translation';
// Browsing
import { trackSelectContent } from '@browsing/tracking';
import { ModalOverlay, ModalWrapper, TermsWrapper, TermsHeader, TermsContent, CloseButton, TermsTitle, } from './styles';
export var BirthdayVoucherTermsAndConditions = function (_a) {
    var _b, _c;
    var open = _a.open, onClose = _a.onClose, customerIncentive = _a.customerIncentive;
    var translate = useTranslate('mylounge', { root: true });
    var handleCloseModal = function () {
        trackSelectContent('birthday_voucher_banner', 'click', {
            contentId: 'close',
        });
        onClose();
    };
    return (React.createElement(Modal, { dismissable: false, open: open, onOpenChange: onClose, purpose: "NON_COMMERCIAL", role: "dialog", size: ModalSize.S, sizeSm: ModalSize.S },
        React.createElement(ModalOverlay, { dismissLabel: translate('shared.close'), onClick: handleCloseModal },
            React.createElement(ModalWrapper, { onClick: function (e) { return e.stopPropagation(); } },
                React.createElement(TranslateScope, { path: "birthdayVoucher" },
                    React.createElement(TermsWrapper, null,
                        React.createElement(TermsHeader, null,
                            React.createElement("div", null,
                                React.createElement(Translate, { message: "claimForm.termsAndConditions" })),
                            React.createElement(CloseButton, { "aria-label": translate('shared.close'), onClick: handleCloseModal },
                                React.createElement(CrossS, null))),
                        React.createElement(TermsTitle, { preset: TitlePreset.M }, (_b = customerIncentive.legal_terms) === null || _b === void 0 ? void 0 : _b.title),
                        React.createElement(TermsContent, null,
                            React.createElement(Text, { preset: Preset.M }, (_c = customerIncentive.legal_terms) === null || _c === void 0 ? void 0 : _c.description))))))));
};
